// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1PV1B","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2CYO-"};